<template>
  <div>
    <el-image-viewer
      v-if="isShow"
      :on-close="ViewerClose"
      :url-list="imgPathList"
    ></el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer,
  },
  props: {
    imgPathList: {
      type: Array,
      default() {
        return [];
      },
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
  methods: {
    // 关闭弹窗
    ViewerClose() {
      this.$emit("update:isShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-icon-circle-close:before {
  color: #fff;
}
</style>